<div class="main-container">
    <div class="checkins-header">
        <div class="title-container">
            <h2 class="checkins-header-title">{{'custom_poll_onboarding_temp_checkins_title' | translate}}</h2>
            <div class="question-mark-tip-container">
                <i class="bi bi-question-circle-fill me-1 text-warning"></i>
                <span [innerHTML]="(this.currentPoll.customPollTemplate.type === 'onboarding' ? 'custom_poll_onboarding_temp_checkins_title_tip':'custom_poll_dysfunctional_temp_checkins_title_tip') | translate"></span>
            </div>
        </div>
        <div class="checkins-main-body">
            <div class="checkins-category-container">
                <form class="category-form" [formGroup]="checkinsForm">
                    <div (click)="getCheckinStatements(checkin.uuid, i)" [ngClass]="selectedCategoryToShowStatements[i] ? 'selected':''" class="category-container" *ngFor="let checkin of checkinsCategories, let i = index">
                        <div class="category-header">
                            <input class="category-check" type="checkbox"
                                [ngClass]="checkin.mandatory ? 'locked':''" 
                                [checked]="checkin.selected || checkin.mandatory" 
                                [disabled]="checkin.mandatory" 
                                (change)="onChange(checkin.uuid, checkin.title, false, $event)"
                                (click)="$event.stopPropagation()">
                            <h2 class="category-check-title">{{checkin.title}}</h2>
                            <img class="lock-icon" *ngIf="checkin.mandatory" src="../../../../../assets/svg/lock.svg">
                            <div class="lock-info-container">
                                <img class="info-circle-icon" src="../../../../../assets/svg/info_circle_icon.svg">
                                <span>{{'custom_poll_onboarding_temp_lock_text' | translate}}</span>
                            </div>
                            <i [ngClass]="selectedCategoryToShowStatements[i] ? 'checked':''" class="bi bi-chevron-right"></i>
                        </div>
                        <div [ngClass]="{'dysfunctional' : this.currentPoll.customPollTemplate.type === 'dysfunctional'}" class="category-check-description" [innerHTML]="checkin.description"></div>
                    </div>
                </form>
            </div>
            <div class="checkins-category-statements-container">
                <h2 style="font-size: 1.8rem">{{'custom_poll_gen_categ_prew' | translate}}</h2>
                <div [ngStyle]="checkinCategoryStatements.length ? {}:{'align-items':'center'}" class="checkins-category-statement-main">
                    <span *ngIf="!checkinCategoryStatements.length && defaultCategoryStart" class="no-statements-info">{{'custom_poll_onboarding_temp_checkin_no_statements' | translate}}</span>
                    <div class="checkins-category-statement" *ngFor="let statement of checkinCategoryStatements,let index = index">
                        <p-accordion *ngIf="!defaultCategoryStart && checkinCategoryStatements.length >= 1 && (statement.question.extraQuestion || statementsExtraQuestions[index]?.length !== 0)" collapseIcon="bi bi-chevron-up" expandIcon="bi bi-chevron-down" (onOpen)="onOpenAccordion($event, index)">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <span class="statement-title" [innerHTML]="statement.question.title" [ngClass]="defaultCategoryStart ? 'default-statement-title':''"></span>
                                    <div class="quote" *ngIf="!defaultCategoryStart">
                                        <i class="bi bi-quote"></i>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                    <div class="extra-question-container" *ngFor="let extraQuestion of statementsExtraQuestions[index]">
                                        <div class="quote">
                                            <i class="bi bi-quote"></i>
                                        </div>
                                        <span class="statement-title">{{extraQuestion.title}}</span>
                                    </div>
                                </ng-template>
                            </p-accordionTab>
                        </p-accordion>
                        <div class="d-flex align-items-center" [ngStyle]="{'gap':'.8rem'}" *ngIf="!defaultCategoryStart && checkinCategoryStatements.length >= 1 && (!statement.question.extraQuestion && statementsExtraQuestions[index]?.length === 0)">
                            <div class="quote" *ngIf="!defaultCategoryStart">
                                <i class="bi bi-quote"></i>
                            </div>
                            <span class="statement-title" [innerHTML]="statement.question.title" [ngClass]="defaultCategoryStart ? 'default-statement-title':''"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="checkins-footer">
        <button class="checkins-back-btn" (click)="saveAndFinish()" pButton type="button" label="{{'custom_poll_gen_categ_back_btn' | translate}}"></button>
        <span class="save-and-finish-later" (click)="saveAndFinish()">{{'custom_poll_gen_categ_save_and_finish' | translate}}</span>
        <button class="checkins-next-btn" 
            pButton type="button" 
            label="{{'custom_poll_onboarding_temp_checkin_next_step_btn' | translate}}"
            (click)="nextStep()"></button>
    </div>
</div>